import React from "react";
import { CardElement } from "react-stripe-elements";
export class CreditCardForm extends React.Component {
  constructor(props) {
    super(props);
  }
  public render() {
    return <CardElement />;
  }
}



// WEBPACK FOOTER //
// ./src/components/stripe/CreditCardForm.tsx